module.exports = __webpack_public_path__ + "img/laravel-fullstack-app4.9658bb14.png";